import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  Divider,
  Grid,
  Button,
  Box,
} from "@mui/material"

import LocationOnIcon from "@mui/icons-material/LocationOn"
import BusinessIcon from "@mui/icons-material/Business"
import EmailIcon from "@mui/icons-material/Email"
import PhoneIcon from "@mui/icons-material/Phone"
import DescriptionIcon from "@mui/icons-material/Description"
import LanguageIcon from "@mui/icons-material/Language"
import BadgeIcon from "@mui/icons-material/Badge"
import PaidIcon from "@mui/icons-material/Paid"
import useTranslationSharie from "../hooks/Language/useTranslation"

export default function BusinessFeedCard({ context_business, context_user }) {
  const t = useTranslationSharie()
  return (
    <Card
      sx={{
        borderRadius: "0.8rem",
        overflow: "hidden",
        boxShadow: 4,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          background: (theme) =>
            `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          color: "text.primary",
          p: 2,
        }}
      >
        <Typography variant='h5' fontWeight='bold'>
          {context_business?.name || "Company Name"}
        </Typography>
        <Typography variant='body2'>
          {context_business?.status || t("No Status provided")}
        </Typography>
      </Box>

      {/* BODY */}
      <CardContent sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {/* Address */}
          <Grid item xs={12} sm={6}>
            <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LocationOnIcon color='primary' />
              {t("Address")}:
            </Typography>
            <Typography variant='body2'>
              {context_business?.address || t("No address provided")}
            </Typography>
          </Grid>

          {/* City */}
          <Grid item xs={12} sm={6}>
            <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <BusinessIcon color='primary' />
              {t("City")}:
            </Typography>
            <Typography variant='body2'>
              {context_business?.city || t("No city provided")}
            </Typography>
          </Grid>

          {/* Country */}
          <Grid item xs={12} sm={6}>
            <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <BusinessIcon color='primary' />
              {t("Country")}:
            </Typography>
            <Typography variant='body2'>
              {context_business?.country || t("No country provided")}
            </Typography>
          </Grid>

          {/* Email */}
          <Grid item xs={12} sm={6}>
            <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <EmailIcon color='primary' />
              {t("Contact Email")}:
            </Typography>
            <Typography variant='body2'>
              {context_business?.email || t("No email provided")}
            </Typography>
          </Grid>

          {/* Phone */}
          <Grid item xs={12} sm={6}>
            <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <PhoneIcon color='primary' />
              {t("Phone Number")}:
            </Typography>
            <Typography variant='body2'>
              {context_business?.phone || t("No phone provided")}
            </Typography>
          </Grid>

          {/* Description */}
          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
            <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <DescriptionIcon color='primary' />
              {t("Description")}:
            </Typography>
            <Typography variant='body2'>
              {context_business?.description || t("No description provided")}
            </Typography>
          </Grid>

          {/* Website */}
          <Grid item xs={12}>
            <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LanguageIcon color='primary' />
              {t("Website URL")}:
            </Typography>
            <Typography variant='body2'>{context_business?.url || t("No URL provided")}</Typography>
          </Grid>

          {/* CRN */}
          <Grid item xs={12} sm={6}>
            <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <BadgeIcon color='primary' />
              {t("CRN")}:
            </Typography>
            <Typography variant='body2'>{context_business?.crn || t("No CRN provided")}</Typography>
          </Grid>

          {/* Credit */}
          <Grid item xs={12} sm={6}>
            <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <PaidIcon color='primary' />
              {t("Credit")}:
            </Typography>
            <Typography variant='body2'>
              {context_business?.status === "paid" ? t("Unlimited") : context_user?.credit}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>

      {/* FOOTER */}
      <CardActions
        sx={{
          justifyContent: "flex-end",
          bgcolor: "grey.100",
        }}
      >
        <Button
          variant='contained'
          color='primary'
          href={context_business?.url || "#"}
          target='_blank'
        >
          {t("Visit Website")}
        </Button>
      </CardActions>
    </Card>
  )
}
